export interface TimelineBlock {
  id: string;
  start: number; // epoch ms
  end: number | null; // null = open deployment (no end date yet)
}

export type TimelineEdge = 'start' | 'end';

export const applyEdgeDrag = (
  blocks: TimelineBlock[],
  index: number,
  edge: TimelineEdge,
  proposedDate: number,
  todayCeiling: number,
): TimelineBlock[] => {
  const next = blocks.map((block) => ({ ...block }));
  const clamped = Math.min(proposedDate, todayCeiling);

  if (edge === 'end') {
    applyEndDrag(next, index, clamped);
  } else {
    applyStartDrag(next, index, clamped);
  }

  return next;
};

const applyEndDrag = (blocks: TimelineBlock[], index: number, proposedDate: number): void => {
  const block = blocks[index];
  if (block.end === null) return; // open deployment has no end ball to drag

  const newEnd = Math.max(proposedDate, block.start);
  block.end = newEnd;
  pushRight(blocks, index + 1, newEnd);
};

const applyStartDrag = (blocks: TimelineBlock[], index: number, proposedDate: number): void => {
  const block = blocks[index];
  const newStart = block.end === null ? proposedDate : Math.min(proposedDate, block.end);
  block.start = newStart;
  pushLeft(blocks, index - 1, newStart);
};

const pushRight = (blocks: TimelineBlock[], index: number, boundary: number): void => {
  if (index >= blocks.length) return;
  const block = blocks[index];
  if (boundary <= block.start) return;

  block.start = boundary;
  if (block.end !== null && block.end < block.start) {
    block.end = block.start;
    pushRight(blocks, index + 1, block.end);
  }
};

function pushLeft(blocks: TimelineBlock[], index: number, boundary: number): void {
  if (index < 0) return;
  const block = blocks[index];
  if (block.end === null) return; // invariant: only the last (open) block can have end=null, and pushLeft never reaches it
  if (boundary >= block.end) return;

  block.end = boundary;
  if (block.start > block.end) {
    block.start = block.end;
    pushLeft(blocks, index - 1, block.start);
  }
}
